import React, { memo, useEffect, useRef, useState, useContext } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Avatar, Icon } from '@material-ui/core';
import { renderTime } from '../../../utils/index';
import avatar from "../../../common/icons/avatar1.png";
import AudioPlayer from './audioPlayer/audioPlayer';
import { EaseChatContext } from "../index";
var useStyles = makeStyles(function (theme) {
  return {
    pulldownListItem: {
      padding: '10px 0',
      listStyle: 'none',
      marginBottom: '26px',
      position: 'relative',
      display: 'flex',
      flexDirection: function flexDirection(props) {
        return props.bySelf ? 'row-reverse' : 'row';
      }
    },
    audioBox: {
      margin: function margin(props) {
        return props.bySelf ? '0 10px 26px 0' : '0 0 26px 10px';
      },
      maxWidth: '50%',
      minWidth: '50px',
      width: function width(props) {
        return "calc(208px * " + props.duration / 15 + ")";
      },
      height: '34px',
      background: function background(props) {
        return props.bySelf ? 'linear-gradient(124deg, rgb(201, 19, 223) 20%, rgb(21, 77, 254) 90%)' : 'rgb(242, 242, 242)';
      },
      borderRadius: function borderRadius(props) {
        return props.bySelf ? '16px 16px 4px' : '16px 16px 16px 4px';
      },
      color: function color(props) {
        return props.bySelf ? '#fff' : 'rgb(0, 0, 0)';
      },
      textAlign: function textAlign(props) {
        return props.bySelf ? 'left' : 'right';
      },
      flexDirection: function flexDirection(props) {
        return props.bySelf ? 'row' : 'row-reverse';
      },
      alignItems: 'center',
      minHeight: '40px',
      lineHeight: '34px',
      padding: '0 5px',
      display: 'flex',
      cursor: 'pointer',
      fontSize: '14px'
    },
    time: {
      position: 'absolute',
      fontSize: '11px',
      height: '16px',
      color: 'rgba(1, 1, 1, .2)',
      lineHeight: '16px',
      textAlign: 'center',
      top: '-18px',
      width: '100%'
    },
    duration: {
      margin: '0 4px',
      position: 'relative',
      left: function left(props) {
        return props.bySelf ? '-15px' : '15px';
      }
    },
    icon: {
      transform: function transform(props) {
        return props.bySelf ? 'rotate(0deg)' : 'rotate(180deg)';
      },
      display: 'block',
      height: '34px'
    }
  };
});

function AudioMessage(_ref) {
  var message = _ref.message,
      showByselfAvatar = _ref.showByselfAvatar;
  var easeChatProps = useContext(EaseChatContext);
  var onAvatarChange = easeChatProps.onAvatarChange;
  var classes = useStyles({
    bySelf: message.bySelf,
    duration: Math.round(message.body.length)
  });
  var url = message.body.url;
  var audioRef = useRef(null);

  var _useState = useState(false),
      isPlaying = _useState[0],
      setIsPlaying = _useState[1];

  var play = function play() {
    setIsPlaying(true);
    audioRef.current.play();
    var time = message.body.length * 1000;
    setTimeout(function () {
      setIsPlaying(false);
    }, time + 500);
  };

  return /*#__PURE__*/React.createElement("li", {
    className: classes.pulldownListItem
  }, !message.bySelf && /*#__PURE__*/React.createElement(Avatar, {
    src: avatar,
    onClick: function onClick() {
      return onAvatarChange && onAvatarChange(message);
    }
  }), showByselfAvatar && message.bySelf && /*#__PURE__*/React.createElement(Avatar, {
    src: avatar
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.audioBox,
    onClick: play
  }, /*#__PURE__*/React.createElement(AudioPlayer, {
    play: isPlaying,
    reverse: message.bySelf
  }), /*#__PURE__*/React.createElement("span", {
    className: classes.duration
  }, Math.floor(message.body.length) + "''"), /*#__PURE__*/React.createElement("audio", {
    src: url,
    ref: audioRef
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.time
  }, renderTime(message.time)));
}

export default memo(AudioMessage);